//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { I18N_LANG_SELECT } from '@/utils/constant';
export default {
  data() {
    return {
      dialogVisible: false, // 添加弹窗开关
      activeNames: ['1', '2'],
      originData: [], // 接口返回值
      textarea: '',
      placeholderText: `可编辑语料内容
例：
field.customer.code=客户编码
其中等号左侧为国际化i18n的查询关键词，右侧为对应语料内容。`,
      editableTabsValue: '2',
      editableTabs: [],
      tabIndex: 2,
      options: [],
      addValue: [],
      optionsItem: [],
    };
  },

  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'internationalization_tenant_add',
        'internationalization_tenant_common',
        'internationalization_tenant_diy',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
  },
  async mounted() {
    await this.initData();
    const arr = this.originData;
    const ans = [];
    if (Array.isArray(arr) && arr.length) {
      arr.forEach((item) => {
        const tmp = {};
        tmp.title = `${I18N_LANG_SELECT[item.lang_type] || ''} ( ${item.lang_type} )`;
        tmp.name = item.lang_type;
        tmp.commonDisable = true;
        tmp.personalDisable = true;
        tmp.commonContent = item.common_text;
        tmp.personalContent = item.personalise_text;
        tmp.activeNames = ['1', '2'];
        ans.push(tmp);
      });
      this.editableTabs = ans;
      this.editableTabsValue = ans[0].name;
    }
    this.initOptions();
  },
  methods: {
    async initData() {
      const request = await this.$request({
        url: this.$api.getInternationConfigList,
        data: {},
      });
      const arr = request.internation_base_info || [];
      this.originData = arr;
    },

    initOptions() {
      const tmp = [];
      Object.keys(I18N_LANG_SELECT).forEach((item) => {
        tmp.push({
          label: `${I18N_LANG_SELECT[item]} ( ${item} )`,
          value: item,
        });
      });
      this.options = tmp;
      this.optionsItem = tmp;
    },

    handleTabsAdd() {
      this.optionsItem = this.options.filter((item) => {
        for (const tmp of this.editableTabs) {
          if (item.value === tmp.name) return false;
        }
        return true;
      }); // 过滤已有选项
      this.dialogVisible = true;
      this.addValue = [];
    },

    async handleCommonEdit(index, type) {
      if (type === 'save') {
        await this.handleSaveData(index);
      }
      this.$set(this.editableTabs[index], 'commonDisable', !this.editableTabs[index].commonDisable);
    },

    async handlePersonalEdit(index, type) {
      if (type === 'save') {
        await this.handleSaveData(index);
      }
      this.$set(
        this.editableTabs[index],
        'personalDisable',
        !this.editableTabs[index].personalDisable,
      );
    },

    async handleSelectData() {
      this.dialogVisible = false;
      try {
        await Promise.all(
          this.addValue.map(async (item) => {
            await this.handleAddData(item);
            this.editableTabs.push({
              title: `${I18N_LANG_SELECT[item] || ''} ( ${item} )`,
              name: item,
              commonContent: '',
              commonDisable: true,
              personalContent: '',
              personalDisable: true,
              activeNames: ['1', '2'],
            });

            this.editableTabsValue = item;
          }),
        );
        this.$message.success('添加成功');
      } catch (e) {
        console.log(e);
      }
    },

    handleCommonCancel(index) {
      this.$set(this.editableTabs[index], 'commonDisable', true);
      this.$set(this.editableTabs[index], 'commonContent', this.originData[index].common_text);
    },

    handlePersonalCancel(index) {
      this.$set(this.editableTabs[index], 'personalDisable', true);
      this.$set(
        this.editableTabs[index],
        'personalContent',
        this.originData[index].personalise_text,
      );
    },

    // 添加调用
    async handleAddData(item) {
      try {
        await this.$request({
          url: this.$api.updateInternationConfigInfo,
          data: {
            lang_type: item,
          },
        });
      } catch (e) {
        this.$message.error(e.message);
      }
    },

    // 保存调用
    async handleSaveData(index) {
      try {
        await this.$request({
          url: this.$api.updateInternationConfigInfo,
          data: {
            lang_type: this.editableTabs[index].name,
            common_text: this.editableTabs[index].commonContent,
            personalise_text: this.editableTabs[index].personalContent,
          },
        });
        console.log(this.editableTabs[index]);
        this.$message.success('保存成功');
        await this.initData();
      } catch (e) {
        console.log(e);
        this.$message.error(e.message);
      }
    },
  },
};
